import Interest from "./Interest";

export default Interest;
